import { useEffect, useState } from 'react';

export interface FormStep<T> {
  key: number;
  name: keyof T;
  isValid: boolean;
  stepSaved: boolean;
}

export const useModalForm = <T,>(initialSteps: FormStep<T>[], { ...forms }) => {
  const [isValid, setIsValid] = useState(false);
  const [formCompleted, setFormCompleted] = useState(false);
  const [allSteps, setAllSteps] = useState<FormStep<T>[]>(initialSteps);
  const [currentTab, setCurrentTab] = useState<FormStep<T>>(initialSteps[0]);

  const saveStep = () => {
    setAllSteps((prev) =>
      prev.map((step) => {
        if (step.key === currentTab.key) {
          return {
            ...step,
            stepSaved: true,
          };
        }

        return step;
      })
    );

    setCurrentTab(allSteps[currentTab.key + 1]);
  };

  const handleTabChange = (key: string) => {
    const tab = allSteps[parseInt(key)];

    setCurrentTab(tab);
  };

  const formsValid = Object.keys(forms).map((key: string) => {
    return forms[key].formState.isValid;
  });

  const allValid = Object.keys(forms).every(
    (key) => forms[key].formState.isValid
  );

  const resetAllForms = () => {
    Object.keys(forms).forEach((key) => {
      forms[key].reset();
    });

    setAllSteps(initialSteps);
    setCurrentTab(initialSteps[0]);
  };

  useEffect(() => {
    if (allValid && currentTab.key === allSteps.length - 1) {
      setFormCompleted(true);
    } else {
      setFormCompleted(false);
    }
  }, [...formsValid, setFormCompleted, currentTab.name, allValid]);

  useEffect(() => {
    setIsValid(
      forms[String(currentTab.name) + 'Form']?.formState.isValid ?? false
    );
  }, [...formsValid, currentTab.name]);

  return {
    isValid,
    setIsValid,
    formCompleted,
    setFormCompleted,
    allSteps,
    setAllSteps,
    currentTab,
    setCurrentTab,
    saveStep,
    handleTabChange,
    resetAllForms,
  };
};
